import { useEffect } from "react";
import { LOGO_URL } from "@/lib/useReveal";

export default function DemoModal({ open, onClose }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            data-testid="demo-modal"
            className="fixed inset-0 z-[100] flex items-center justify-center p-4"
        >
            <div
                className="absolute inset-0 bg-white/60 backdrop-blur-xl"
                onClick={onClose}
                data-testid="demo-modal-backdrop"
            />
            <div className="relative w-full max-w-lg glass-strong rounded-3xl p-8 sm:p-10 text-center">
                <button
                    onClick={onClose}
                    data-testid="demo-modal-close"
                    aria-label="Close"
                    className="absolute top-4 right-4 h-9 w-9 inline-flex items-center justify-center rounded-full hover:bg-black/5 transition-colors"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                    </svg>
                </button>

                <div className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center relative">
                    <div className="absolute inset-0 rounded-2xl anim-pulse-glow"
                         style={{ background: "radial-gradient(closest-side, rgba(139,92,246,0.4), transparent 70%)" }}
                    />
                    <img src={LOGO_URL} alt="" className="logo-blend relative h-14 w-14 object-contain" />
                </div>

                <h3 className="mt-5 font-display text-2xl sm:text-3xl font-medium tracking-tight text-black">
                    Demo coming soon.
                </h3>
                <p className="mt-3 text-[14px] text-neutral-600 leading-relaxed">
                    We’re preparing a private walkthrough of the CEO Command
                    Center. Drop your email and we’ll send an invite.
                </p>

                <form
                    className="mt-6 flex flex-col sm:flex-row gap-2"
                    onSubmit={(e) => {
                        e.preventDefault();
                        onClose();
                    }}
                >
                    <input
                        data-testid="demo-modal-email"
                        type="email"
                        required
                        placeholder="you@company.com"
                        className="flex-1 rounded-full border border-black/10 bg-white px-5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
                    />
                    <button
                        data-testid="demo-modal-submit"
                        type="submit"
                        className="inline-flex items-center justify-center gap-1.5 bg-black text-white text-sm font-medium px-5 py-3 rounded-full hover:shadow-[0_10px_30px_-10px_rgba(139,92,246,0.6)]"
                    >
                        Notify me
                    </button>
                </form>
            </div>
        </div>
    );
}
